<div class="card mt-4">
  <h4 class="card-header">{{ selectedTab() === 'gates' ? 'Gates Available' : 'Devices' }}</h4>
  <div class="card-body">
    <ul class="nav nav-tabs mb-3" aria-label="Access controls">
      <li class="nav-item"><button id="operate-gates-tab" type="button" class="nav-link" [class.active]="selectedTab() === 'gates'" [attr.aria-pressed]="selectedTab() === 'gates'" aria-controls="operate-gates-panel" (click)="selectedTab.set('gates')">Gates</button></li>
      <li class="nav-item"><button id="operate-devices-tab" type="button" class="nav-link" [class.active]="selectedTab() === 'devices'" [attr.aria-pressed]="selectedTab() === 'devices'" aria-controls="operate-devices-panel" (click)="selectDevicesTab()">Devices</button></li>
    </ul>
    <section id="operate-gates-panel" aria-labelledby="operate-gates-tab" [hidden]="selectedTab() !== 'gates'">

    @for (device of devices(); track device) {
      <div class="custom-control custom-switch main-switch-{{device.id}}">
        <div class="d-inline px-2app cntrl-label">{{device.labeltxt}}</div>
        @if (device.id == 1) {
          <div class="d-inline">
            <button class="btn btn-outline-primary camera-control" (click)="displayCamera(device.id)"><fa-icon [icon]="faCamera"></fa-icon></button>
          </div>
        }
        <div class="d-inline cntrl-btn">
          <label class="switch">
            <input type="checkbox" [value]="device.name" [id]="device.id" (change)="toggleDevice($event,device.name,device.id)">
            <span class="slider round"></span>
          </label>
          <!-- <label class="switch">
          <!-- <input type="checkbox"> -->
          <!--   <input type="checkbox" [(ngValue)]="device.name" [id]="device.id" (change)="toggleDevice($event.target.checked,device.name,device.id)">
          <span class="slider round"></span>
        </label> -->
      </div>
      <!-- <div class="camera-preview d-none camera-preview-{{device.id}}">
      <img src="http://192.168.0.249/tmpfs/auto.jpg" >
    </div>    -->
  </div>
}
    </section>
    <section id="operate-devices-panel" aria-labelledby="operate-devices-tab" [hidden]="selectedTab() !== 'devices'">
      @if (devicesTabOpened()) { <app-smart-devices></app-smart-devices> }
    </section>
</div>
</div>
